export function shouldHideGroupSections({
  hasActive1on1Plan,
  hasActiveGroupPlan,
}: {
  hasActive1on1Plan: boolean;
  hasActiveGroupPlan: boolean;
}): boolean {
  return hasActive1on1Plan && !hasActiveGroupPlan;
}
